import { render, staticRenderFns } from "./ParticipantCard.vue?vue&type=template&id=03816ffe"
import script from "./ParticipantCard.vue?vue&type=script&lang=js"
export * from "./ParticipantCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports